import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import { requestNotificationPermission } from './firebase';
import './global';
import './App.css';

import { SessionProvider } from './SessionContext';
import ProtectedRoute from './ProtectedRoute';

import Menu from './components/menu';

import SignIn from './pages/sign-in';
import Dashboard from './pages/dashboard';
import Trips from './pages/trips';
import Mytrips from './pages/mytrips';
import AllTrips from './pages/alltrips';
import Destinies from './pages/destinies';
import Settings from './pages/settings';
import Tickets from './pages/tickets';
import Roles from './pages/roles';
import Notifications from './pages/notifications';
import AccessDenied from './pages/AccessDenied';
import JobPlanner from './pages/jobPlanner';

const AuthenticatedPage = ({ active, children }) => {
    return (
        <ProtectedRoute>
            <>
                <Menu active={active} />
                {children}
            </>
        </ProtectedRoute>
    );
};

function App() {
    useEffect(() => {
        const initializeNotifications = async () => {
            try {
                await requestNotificationPermission();
            } catch (error) {
                console.error(
                    'Erro ao inicializar notificações:',
                    error
                );
            }
        };

        initializeNotifications();
    }, []);

    return (
        <div className="main-screen">
            <SessionProvider>
                <Router>
                    <Routes>
                        <Route
                            path="/"
                            element={<SignIn />}
                        />

                        <Route
                            path="/dashboard"
                            element={
                                <AuthenticatedPage active="dashboard">
                                    <Dashboard />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/trips"
                            element={
                                <AuthenticatedPage active="trips">
                                    <Trips />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/mytrips"
                            element={
                                <AuthenticatedPage active="mytrips">
                                    <Mytrips />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/all-trips"
                            element={
                                <AuthenticatedPage active="all-trips">
                                    <AllTrips />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/destinies"
                            element={
                                <AuthenticatedPage active="destinies">
                                    <Destinies />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/settings"
                            element={
                                <AuthenticatedPage active="settings">
                                    <Settings />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/tickets"
                            element={
                                <AuthenticatedPage active="tickets">
                                    <Tickets />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/roles"
                            element={
                                <AuthenticatedPage active="roles">
                                    <Roles />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/notifications"
                            element={
                                <AuthenticatedPage active="notifications">
                                    <Notifications />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/job-planner"
                            element={
                                <AuthenticatedPage active="job-planner">
                                    <JobPlanner />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="/500"
                            element={
                                <AuthenticatedPage active="access-denied">
                                    <AccessDenied />
                                </AuthenticatedPage>
                            }
                        />

                        <Route
                            path="*"
                            element={
                                <Navigate
                                    to="/dashboard"
                                    replace
                                />
                            }
                        />
                    </Routes>
                </Router>
            </SessionProvider>
        </div>
    );
}

export default App;